/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.section`
  *,
  :after,
  :before {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  display: none;
  @media (min-height: 300px) {
    display: table;
  }
  position: absolute;
  bottom: 30px;
  left: 50%;
  @media (orientation: landscape) {
    bottom: 10px;
  }

  .scroll-down {
    opacity: 0.7;
    -webkit-transition: all 0.5s ease-in 3s;
    transition: all 0.5s ease-in 3s;
    margin-left: -16px;
    display: block;
    width: 32px;
    height: 32px;
    border: 2px solid #fff;
    background-size: 14px auto;
    border-radius: 50%;
    z-index: 2;
    -webkit-animation: bounce 2s infinite 2s;
    animation: bounce 2s infinite 2s;
    -webkit-transition: all 0.2s ease-in;
    transition: all 0.2s ease-in;
    transform: scale(1);

  }

  .scroll-down:before {
    position: absolute;
    top: calc(50% - 8px);
    left: calc(50% - 6px);
    transform: rotate(-45deg);
    display: block;
    width: 12px;
    height: 12px;
    content: '';
    border: 2px solid white;
    border-width: 0px 0 2px 2px;
  }

  @keyframes bounce {
    0%,
    100%,
    20%,
    50%,
    80% {
      -webkit-transform: translateY(0);
      -ms-transform: translateY(0);
      transform: translateY(0);
    }
    40% {
      -webkit-transform: translateY(-10px);
      -ms-transform: translateY(-10px);
      transform: translateY(-10px);
    }
    60% {
      -webkit-transform: translateY(-5px);
      -ms-transform: translateY(-5px);
      transform: translateY(-5px);
    }
  }
`;
function ScrollDown() {
  return (
    <Wrapper className="header-scroll-down framing-slider">
      <a href="#framing" className="scroll-down" aria-label="Scroll down" data-uk-scroll role="button"></a>
    </Wrapper>
  );
}

export default ScrollDown;



// WEBPACK FOOTER //
// ./src/features/header/ScrollDown.js